
import React, { useState } from 'react';
import { AutoComplete, Input } from "antd";
import { ReactComponent as SearchIcon } from '../../../../../assets/icons/search_icon_purple.svg';

import '../../../../../styles/pages/_searchBarComponent.scss';

const SearchComponent = () => {
    const [saytOptions, setSaytOptions] = useState([]); 
    const [detailedPayload, setDetailedPayload] = useState({ saytKey: '' });

    // Handlers for AutoComplete and Input.Search
    const handleSAYT = (value) => {
        // Implement search logic here
    };

    const onSAYTSelect = (value) => {
        // Implement selection logic here
    };

    const onSAYTChange = (value) => {
        // Implement change logic here
    };

    const onSAYTSearch = (value) => {
        // Implement search submit logic here
    };

    // Prefix for the Input.Search component
    const prefix = <SearchIcon />;

    return (
        <div>
            <AutoComplete
                // popupClassName="certain-category-search-dropdown"
                popupMatchSelectWidth={500}
                style={{ width: "100%" }}
                options={saytOptions}
                onSearch={handleSAYT}
                onSelect={onSAYTSelect}
                onChange={onSAYTChange}
                defaultValue={detailedPayload.saytKey}
            >
                <Input.Search
                    onSearch={onSAYTSearch}
                    variant="borderless"
                    allowClear={true}
                    prefix={prefix}
                    className="sayt-input-filter input-filter"
                    size="large"
                    placeholder="Search with Process Definition ID, Process Instance ID, Business Key, Owner, Current Assignee, Active Task Name "
                    enterButton
                />
            </AutoComplete>
        </div>
    );
};

export default SearchComponent;
